import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import * as _ from "../../../util/lodash";
import Layout from "../../core/layout";
import Button from "../../core/button";
import Label from "../../core/label";
import CKImage from "../../core/image";
import EmptyState from "../../core/empty-state";
import * as FileUtils from "../../core/asset-uploader/file-utils";
import assetRefService from "../../../util/asset";
import PexelsInfo from "./pexels-info";
import { positions, sizes, widths, textAlignments, font, directions, uploadAssetTypes, assetServices, icons } from "../../../enums";
var noPadding = {
  padding: 0
};

var isAssetPortrait = _.memoize(function (asset) {
  return FileUtils.isAssetPortrait(asset.width, asset.height);
}, function (asset) {
  return "cache-" + asset.width + "-" + asset.height;
});
/**
 * Subcomponent for the repeating label with the same styles
 */


var HeaderLabel = function HeaderLabel(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement(Label, {
    text: text,
    font: {
      emphasis: font.emphasis.CAPS
    },
    size: sizes.X2,
    style: noPadding
  });
};
/**
 * Pexels Assets List - shows a list of free images, we can select and use in our applications
 */


var PexelsAssetList = function PexelsAssetList(_ref2) {
  var list = _ref2.list,
      onAssetSelected = _ref2.onAssetSelected,
      isCompact = _ref2.isCompact,
      searchQuery = _ref2.searchQuery;

  /**
   * Selects Pexels image from the list, prepares an assetRef object to be handled the same way, as standard assets
   */
  var handleOnSelect = function handleOnSelect(e, _ref3) {
    var _asset = _ref3.value;
    onAssetSelected(_extends({}, _asset, {
      assetRef: assetRefService.serialize({
        service: assetServices.PEXELS,
        assetType: uploadAssetTypes.IMAGE,
        dim: _asset.width + "x" + _asset.height,
        location: _asset.path
      }),
      assetPath: _asset.path
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "asset-select"
  }, /*#__PURE__*/React.createElement(PexelsInfo, null), /*#__PURE__*/React.createElement("div", {
    className: "asset-select__header"
  }, /*#__PURE__*/React.createElement(Layout, {
    columnStyles: {
      textAlign: textAlignments.CENTER,
      verticalAlign: positions.verticalAlign.MIDDLE
    }
  }, /*#__PURE__*/React.createElement(Layout.Row, {
    columns: widths.SEVEN
  }, /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.TWO,
    textAlign: textAlignments.LEFT
  }, /*#__PURE__*/React.createElement(HeaderLabel, {
    text: "Title"
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.FOUR
  }), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.THREE
  }, /*#__PURE__*/React.createElement(HeaderLabel, {
    text: "Size"
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.FOUR
  }, /*#__PURE__*/React.createElement(HeaderLabel, {
    text: "Created by"
  })), /*#__PURE__*/React.createElement(Layout.Column, {
    columnWidth: widths.THREE
  })))), /*#__PURE__*/React.createElement("div", {
    className: cx('asset-select__list', {
      'asset-select__list--modal': isCompact
    })
  }, /*#__PURE__*/React.createElement(Layout, {
    borders: directions.H,
    columnStyles: {
      textAlign: textAlignments.CENTER,
      verticalAlign: positions.verticalAlign.MIDDLE
    }
  }, _mapInstanceProperty(list).call(list, function (asset, assetIdx) {
    return /*#__PURE__*/React.createElement(Layout.Row, {
      columns: widths.SEVEN,
      key: 'asset' + assetIdx
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.TWO,
      textAlign: textAlignments.LEFT
    }, /*#__PURE__*/React.createElement("div", {
      className: cx('file-thumbnail-wrapper', {
        'file-thumbnail-wrapper--landscape': !isAssetPortrait(asset),
        'file-thumbnail-wrapper--portrait': isAssetPortrait(asset)
      })
    }, /*#__PURE__*/React.createElement(CKImage, {
      src: "" + asset.thumbnailAssetPath
    }))), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR,
      textAlign: textAlignments.LEFT
    }, /*#__PURE__*/React.createElement(Label, {
      text: asset.name,
      isFluid: true,
      style: noPadding,
      font: {
        weight: font.weights.MEDIUM
      },
      size: sizes.MEDIUM
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.THREE
    }, /*#__PURE__*/React.createElement(Label, {
      text: asset.width ? asset.width + "x" + asset.height + "px" : '',
      isFluid: true,
      style: noPadding
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.FOUR
    }, /*#__PURE__*/React.createElement(Label, {
      text: asset.photographer,
      style: noPadding,
      isFluid: true
    })), /*#__PURE__*/React.createElement(Layout.Column, {
      columnWidth: widths.THREE
    }, /*#__PURE__*/React.createElement(Button.Primary, {
      text: "Select",
      onClick: handleOnSelect,
      value: asset,
      size: sizes.X1
    })));
  }, this)), !list.length ? /*#__PURE__*/React.createElement(Layout, {
    style: {
      marginTop: '220px'
    },
    isCentered: true
  }, /*#__PURE__*/React.createElement(EmptyState, {
    icon: icons.INFO,
    header: searchQuery ? 'There are no matches for your search' : 'No items to display...Yet!',
    byline: searchQuery ? '' : 'Search for images by typing in the search box above.'
  })) : null));
};

PexelsAssetList.propTypes = {
  onAssetSelected: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    color: PropTypes.string,
    path: PropTypes.string,
    thumbnailAssetPath: PropTypes.string,
    photographer: PropTypes.string
  })),
  isCompact: PropTypes.bool,
  searchQuery: PropTypes.string
};
PexelsAssetList.defaultProps = {
  list: [],
  isCompact: false,
  searchQuery: undefined
};
export default PexelsAssetList;
//# sourceMappingURL=pexels-asset-list.js.map